import * as React from 'react'
let selectedUnit = 'C'

const temperatureUnitReducer = (state: string, action: {type: string}) => {
    switch (action.type) {
        case 'SET_DEGREE_F':
            selectedUnit = 'F'
            return 'F'
        case 'SET_DEGREE_C':
            selectedUnit = 'C'
            return 'C'
        default:
            return state
    }
}

const TemperatureUnitContext = React.createContext<[string, React.Dispatch<{ type: string; }>]>(['C', () => undefined])

export const TemperatureUnitProvider = ({ children }: {children: React.ReactNode}) => {
    return (
        <TemperatureUnitContext.Provider
            value={React.useReducer(temperatureUnitReducer, selectedUnit)}
        >
            {children}
        </TemperatureUnitContext.Provider>
    )
}
export const useTemperatureUnitContext = () =>
    React.useContext(TemperatureUnitContext)
